import styled from 'styled-components';

const StyledVehiclesContainer = styled.div`
	position: absolute;
	top: 341px;
	left: 0;
`;

const StyledVehiclesList = styled.div`
	padding-left: 60px;
`;

export { StyledVehiclesContainer, StyledVehiclesList };
